import script from "./WelcomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeView.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeView.vue?vue&type=style&index=0&id=091b0896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-091b0896"]])

export default __exports__